import { NumberValue, VALUE_TYPE } from "Components/NumberValue";
import {
  ExtendCoverageCheckbox,
  ExtendCoverageContainer,
} from "./coverages.styles";

import { getComponentTextByFieldId } from "Components/TextContext";
import { Data } from "Components/TextContext/textInterfaces";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import { useField } from "formik";
import React from "react";
import { CoveragePriceCalculation } from "./coverages.types";

interface Props {
  baseCost: number;
  baseCoverage: InsuranceCoverage;
  coverage: CoveragePriceCalculation;
  fieldName: string;
  priceFilterValue?: string;
  textComponents: Data[];
}

export const ExtendedCoverage = (props: Props): React.ReactElement => {
  const {
    baseCost,
    baseCoverage,
    coverage,
    fieldName,
    priceFilterValue,
    textComponents,
  } = props;
  const [fieldProps, fieldMeta, fieldHelpers] = useField(fieldName);

  const coverageName = coverage[0];
  const price =
    coverage[1].prices.filter((entry) => entry.value === priceFilterValue)[0] ||
    coverage[1].prices[0];
  const extraCost = Math.round(Number(price.monthlyPrice) - baseCost);

  return (
    <ExtendCoverageContainer>
      <label>
        <ExtendCoverageCheckbox
          type="checkbox"
          id={`extended-coverage-${coverageName}`}
          name={`extended-coverage-${coverageName}`}
          value={coverageName}
          checked={fieldMeta.value === coverageName}
          onBlur={fieldProps.onBlur}
          onChange={() => {
            fieldHelpers.setValue(
              fieldMeta.value === coverageName ? baseCoverage : coverageName,
            );
          }}
        />
        {getComponentTextByFieldId(
          textComponents,
          `coveragelabel-${coverageName.toLowerCase()}`,
        )}
      </label>
      <p>
        + <NumberValue value={extraCost} type={VALUE_TYPE.NOK_MONTH} />
      </p>
    </ExtendCoverageContainer>
  );
};
